module.exports = __webpack_public_path__ + "static/media/inf_36pog48p.e508b907.mp3";